import React from "react";

import {
  Box,
  useColorModeValue,
  Tag,
  Text,
  Flex,
  Stack,
  Heading,
  HStack,
  Link,
  Image,
  Button,
} from "@chakra-ui/react";
import { FaGithubAlt,FaLink } from "react-icons/fa";

function ProjectItem({ title, description, language, url, link, image }) {
  return (
    <Box
      px={4}
      py={5}
      borderWidth="1px"
      borderColor="gray.200"
      _hover={{ shadow: "lg" }}
      bg={useColorModeValue("white", "gray.700")}
      position="relative"
      rounded="md"
    >
      <Flex justifyContent="space-between">
        <Flex>
          <Stack spacing={1} pl={3} align="left">
            <Link target="_blank" href={url} textDecoration="none">
              <HStack cursor="pointer">
                <FaGithubAlt />
                <Heading
                  align="left"
                  color="blue.400"
                  fontWeight="medium"
                  fontStyle="oblique"
                  fontSize={15}
                >
                  {title}
                </Heading>

              </HStack>
            </Link>
            <Button as='a'
            href={link}
              variant="outline"
              colorScheme="teal"
              aria-label="Send email"
              icon={<FaLink /> }
              w='16'
              target='_blank'
            >Go Live </Button>
           
            <Box >
              <Image src={image} pt={4} alt="project image" w='100%'
              display={['block',"block","block"]} />
            </Box>

            {language && (
              <Stack
                spacing={1}
                isInline
                alignItems="center"
                display={ "flex"}
              >
                
                <Tag size="sm" padding="1">
                  {language}
                </Tag>
              </Stack>
            )}

<Text pt={4} align="left" fontSize="sm" >
          {description}
        </Text>
          </Stack>
        </Flex>
      </Flex>
    </Box>
  );
}

export default ProjectItem;
